import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "text-large fw-bold mr-3" }
const _hoisted_3 = {
  key: 0,
  class: "section-sport d-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_5 = { class: "me-2 fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "me-2 fw-bold" }, "Nominal", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12 col-md-6 col-lg-3" }
const _hoisted_10 = { class: "sticky-lg-top" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 col-lg-9" }
const _hoisted_12 = { class: "card mb-4 mb-xxl-6" }
const _hoisted_13 = { class: "card-body pt-4 pb-0" }
const _hoisted_14 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "me-7 mb-4"
}
const _hoisted_16 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "d-flex align-items-center mb-2" }
const _hoisted_22 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_23 = { href: "#" }
const _hoisted_24 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_25 = { class: "list-unstyled" }
const _hoisted_26 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill me-2 fs-3" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill" }, null, -1)
const _hoisted_29 = {
  class: "demo-rich-conent",
  style: {"display":"flex","gap":"16px","flex-direction":"column"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder mb-0" }, "Representante", -1)
const _hoisted_31 = { class: "fs-1x" }
const _hoisted_32 = { class: "list-unstyled" }
const _hoisted_33 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill me-2 fs-3" }, null, -1)
const _hoisted_35 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope-at-fill me-2 fs-3" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-0" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" })
], -1)
const _hoisted_39 = { class: "card card-custom mb-4" }
const _hoisted_40 = { class: "card-header flex-wrap px-3" }
const _hoisted_41 = { class: "card-title" }
const _hoisted_42 = { class: "card-toolbar" }
const _hoisted_43 = { class: "d-flex align-items-center mr-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down fs-1x text-white ms-3" }, null, -1)
const _hoisted_45 = {
  key: 0,
  class: "fa fa-cog fa-spin text-white ms-2 fs-2 p-0"
}
const _hoisted_46 = {
  key: 1,
  class: "bi bi-cloud-arrow-down-fill text-white ms-2 fs-1 me-0 p-0"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary ms-3" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary ms-3" }, null, -1)
const _hoisted_49 = { class: "card card-custom" }
const _hoisted_50 = { class: "card-header flex-wrap px-3" }
const _hoisted_51 = { class: "card-title" }
const _hoisted_52 = { class: "card-toolbar" }
const _hoisted_53 = { class: "me-2 fw-bolder" }
const _hoisted_54 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "symbol symbol-30 symbol-light-success me-3" }
const _hoisted_58 = {
  class: "text-dark-50",
  style: {"line-height":"1.25"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_61 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_62 = {
  key: 0,
  class: "bi bi-check2 text-primary fs-2"
}
const _hoisted_63 = {
  key: 1,
  class: "bi bi-x-circle text-danger fs-2"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_69 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_MixedWidget1 = _resolveComponent("MixedWidget1")!
  const _component_MixedWidget14 = _resolveComponent("MixedWidget14")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DialogAcrd = _resolveComponent("DialogAcrd")!
  const _component_ModalObservaciones = _resolveComponent("ModalObservaciones")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogNominal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogNominal) = $event)),
      fullscreen: true,
      class: "bg-light",
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed
    }, {
      header: _withCtx(({ }) => [
        _createVNode(_component_el_page_header, {
          icon: _ctx.ArrowLeft,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogNominal = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_avatar, {
                size: 32,
                class: "me-3",
                src: _ctx.evento.logo
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.evento.name), 1),
              (_ctx.sport?.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sport.name), 1),
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: `Inscripciones ${_ctx.closure?.mstatus == 'O' ? 'habilitadas' : 'finalizadas'}`,
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.sport?.name)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(`bg-${_ctx.closure?.mstatus == 'O' ? 'success pulse-success' : 'danger pulse-danger'} rounded-circle border border-2 border-white h-20px w-20px`)
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_scrollbar, {
                height: `${_ctx.altura + 95}px`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MixedWidget1, {
                    "widget-classes": "card-xl-stretch mb-xl-4",
                    "widget-color": "primary",
                    loading: _ctx.loaderSumary,
                    "widget-title": _ctx.t('acrd9'),
                    "widget-amount": _ctx.total,
                    "items-list": _ctx.listRCheckDoc,
                    "items-two": _ctx.listRGender
                  }, null, 8, ["loading", "widget-title", "widget-amount", "items-list", "items-two"]),
                  _createVNode(_component_MixedWidget14, {
                    "widget-classes": "card-xxl-stretch mb-4 mb-xl-6",
                    "widget-color": "#d9f5f8",
                    loading: _ctx.loaderSumary,
                    title: _ctx.t('acrd10'),
                    items: _ctx.listRTRegister
                  }, null, 8, ["loading", "title", "items"])
                ]),
                _: 1
              }, 8, ["height"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.rowClub?.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_el_image, {
                            style: {"width":"auto","height":"130px"},
                            src: _ctx.rowClub?.logo,
                            fit: 'cover'
                          }, null, 8, ["src"]),
                          _hoisted_17
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.rowClub?.business) + "(" + _toDisplayString(_ctx.rowClub?.abrev) + ") ", 1),
                          _createElementVNode("a", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_ctx.repman.person)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                _createVNode(_component_el_popover, {
                                  width: 300,
                                  "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _hoisted_27,
                                      _createTextVNode(" " + _toDisplayString(_ctx.repman?.person) + " ", 1),
                                      _hoisted_28
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createVNode(_component_el_avatar, {
                                        size: 60,
                                        src: `${_ctx.repo}/uploads/${_ctx.repman.photo}`,
                                        style: {"margin-bottom":"8px"}
                                      }, null, 8, ["src"]),
                                      _createElementVNode("div", null, [
                                        _hoisted_30,
                                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.repman.person), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_32, [
                                        (_ctx.repman.phone1)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                              _hoisted_34,
                                              _createTextVNode("Celular: " + _toDisplayString(_ctx.repman.phone1), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.repman.email1)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                              _hoisted_36,
                                              _createTextVNode("Email: " + _toDisplayString(_ctx.repman.email1), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _hoisted_37
                    ]),
                    _hoisted_38
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.tregister,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tregister) = $event)),
                    onChange: _ctx.getListNominal,
                    class: "me-3"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.tregister, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: `erb-${index}`,
                          label: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    (_ctx.multipleSelection.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 0,
                          class: "me-3"
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Aprobar")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Anular")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Subsanar")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Transferir")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, { onClick: _ctx.activeCredential }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Credencial")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, { type: "primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ejecutar "),
                                _hoisted_44
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'nominal', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ficha Nominal ")
                              ]),
                              _: 1
                            }),
                            (_ctx.sport.categorie == 1)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  command: "a",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'auxiliar', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Ficha Auxiliar "),
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: "Descargar y presentar un dia antes del inicio de la competencia",
                                      placement: "bottom"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_47
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.sport?.fnc == 1)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  command: "a",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', `nominal/${_ctx.sport.slug}`, {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Nominal de competencia ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'remarks', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Observaciones ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'checklist', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" CheckList ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'zebra-zc300', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Zebra ZC300 ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _ctx.generateCredentials
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Credenciales "),
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Solo para registros aprobados",
                                  placement: "bottom"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_48
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.DownloadXLSXPDF('zip', 'fotos', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.mbtoa(_ctx.rowClub.idinstitution),
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Fotos ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          class: "me-3"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.loaderDownload)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                              : (_openBlock(), _createElementBlock("i", _hoisted_46)),
                            _createTextVNode(" " + _toDisplayString(_ctx.t('download')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchText,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchText) = $event)),
                    placeholder: _ctx.t('search'),
                    "prefix-icon": _ctx.Search,
                    clearable: "",
                    class: "w-300px me-3"
                  }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t('state')), 1),
                  _createVNode(_component_el_select, {
                    class: "w-200px",
                    modelValue: _ctx.listChecks,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listChecks) = $event)),
                    onChange: _ctx.getListNominal,
                    multiple: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    placeholder: "Estado"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "singleTableRef",
              data: _ctx.filteredNominal,
              onSelectionChange: _ctx.handleSelectionChange,
              border: "",
              style: {"width":"100%"},
              height: _ctx.altura - 80,
              "scrollbar-always-on": true,
              "highlight-current-row": "",
              "default-sort": { prop: 'created_at', order: 'descending' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "docnumber",
                  label: _ctx.t('document'),
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.doc_name), 1),
                      _hoisted_55,
                      _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "persona",
                  label: _ctx.t('participant'),
                  width: "250"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", {
                      class: "d-flex align-items-center text-hover-primary cursor-pointer",
                      onClick: ($event: any) => (_ctx.onDialogAcrd(scope.row))
                    }, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_el_avatar, {
                          shape: "square",
                          size: "default",
                          fit: "contain",
                          src: `${_ctx.repo}/uploads/${scope.row.photo}`,
                          class: _normalizeClass('border')
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", null, _toDisplayString(scope.row.firstname.toUpperCase()), 1),
                        _hoisted_59,
                        _createElementVNode("span", null, _toDisplayString(scope.row.lastname.toUpperCase() + ' ' + scope.row.surname.toUpperCase()), 1)
                      ])
                    ], 8, _hoisted_56)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "gender",
                  label: _ctx.t('gender'),
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.gender == 'M')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(scope.row.gender), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(scope.row.gender), 1))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "edad",
                  label: "Edad"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "function_name",
                  label: _ctx.t('function'),
                  width: "150"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "Cred",
                  align: "center",
                  width: "70"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.credential == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                      : (_openBlock(), _createElementBlock("i", _hoisted_63))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('state'),
                  align: "center",
                  width: "110"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge badge-${scope.row.check_class}`)
                    }, _toDisplayString(scope.row.check_name), 3)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: _ctx.t('registered'),
                  sortable: "",
                  width: "180"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "Opciones",
                  align: "center",
                  width: "150",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row, $index }) => [
                    ((row.checkdoc == 0 || row.checkdoc == 4))
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "dark",
                          content: _ctx.t('edit'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-pencil-square fs-2 text-hover-primary me-4",
                              onClick: ($event: any) => (_ctx.onEdit(row, 2, $index))
                            }, null, 8, _hoisted_64)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : _createCommentVNode("", true),
                    (row.checkdoc == 0)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 1,
                          effect: "dark",
                          content: _ctx.t('delete'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-trash fs-2 text-hover-danger me-4",
                              onClick: ($event: any) => (_ctx.onDelete(row))
                            }, null, 8, _hoisted_65)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "Ver observaciones",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-exclamation-triangle fs-2 text-hover-danger me-4",
                          onClick: ($event: any) => (_ctx.onObservations(row))
                        }, null, 8, _hoisted_66)
                      ]),
                      _: 2
                    }, 1024),
                    (_ctx.closure?.verify_test == 1)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 2,
                          effect: "dark",
                          content: "Modificar Pruebas",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-bezier2 fs-2 text-hover-danger me-4",
                              onClick: ($event: any) => (_ctx.OnTest(row))
                            }, null, 8, _hoisted_67)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onSelectionChange", "height"])), [
              [_directive_loading, _ctx.loaderTable]
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loaderGral]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_DialogAcrd, {
      evento: _ctx.evento,
      "type-register": _ctx.tregister,
      "row-acrd": []
    }, null, 8, ["evento", "type-register"]),
    _createVNode(_component_ModalObservaciones, { idacrd: _ctx.rowIdObs }, null, 8, ["idacrd"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogCredentials,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogCredentials) = $event)),
      title: "Credenciales",
      width: "350",
      draggable: "",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_69, [
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogCredentials = false)),
            disabled: _ctx.loadingCredential
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.sendActiveCredentials
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.loadingCredential ? 'Guardando' : 'Guardar'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("label", null, _toDisplayString(`${_ctx.optionCredential ? 'Habilitar' : 'Deshabilitar'} ${_ctx.multipleSelection.length} credenciales`), 1),
          _createVNode(_component_el_form_item, { class: "m-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.optionCredential,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.optionCredential) = $event)),
                style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}